import { render, staticRenderFns } from "./srv-dtls.vue?vue&type=template&id=7755d2ec&scoped=true&lang=pug&"
import script from "./srv-dtls.vue?vue&type=script&lang=js&"
export * from "./srv-dtls.vue?vue&type=script&lang=js&"
import style0 from "./srv-dtls.vue?vue&type=style&index=0&id=7755d2ec&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7755d2ec",
  null
  
)

export default component.exports